import clsx from 'clsx';
import React from 'react';
export const FloatingLabel = (props) => {
    const { children, label, required, className, hasValue, ...rest } = props;
    return (React.createElement("div", { className: "relative" },
        children,
        ' ',
        React.createElement("label", { className: clsx({
                'top-5 text-lg': !hasValue,
                'top-2 text-xxs font-semibold': hasValue,
            }, 'absolute left-6 peer-focus:top-2 peer-focus:text-xxs peer-focus:font-semibold text-app-gray-mid transition-all leading-none', className), ...rest },
            label,
            ' ',
            required && (React.createElement("abbr", { title: "required", className: "text-app-red-dark no-underline ml-1" }, "*")))));
};
